const $ = jQuery.noConflict();

'use strict';
const Tabs = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.tabsFunction();
		this.tabFromUrl();
		this.tabsMap();
		this.bindEvents();
	},

	bindEvents: function() {
		$('.menu-item a').on('click', function() {
			Tabs.tabFromUrl();
			Tabs.tabFromLink.call(this);
		});

		if ($('.js-nav-services-block').length) {
			$('.js-nav-services-block li:first-child').trigger('click');
		}
	},

	tabsMap: function() {
		// $('.js-nav-services-block li:first').find('p').slideDown(350);

		$('.js-nav-services-block li').on('click', function() {
			if (!$(this).hasClass('active-link') || !$(this).find('p').is(':visible')) {
				$('.js-nav-services-block li').removeClass('active-link');
				$('.js-nav-services-block li').find('p').slideUp(350);
				$(this).addClass('active-link');
				$(this).find('p').slideDown(350);
				const tagid = $(this).data('tag');
				const textid = $(this).data('text');
				$('.js-services-block-map').removeClass('active');
				$('.js-services-block-map-text').removeClass('active-text');
				$('#' + tagid).addClass('active');
				$('#' + textid).addClass('active-text');
			}
		});


		$('.js-services-block-map').on('click', function(e) {
			const pathId = $(this).data('path');
			$('.js-services-block-map').removeClass('active');
			$(this).addClass('active');

			$('.js-tab-btn-services-block').removeClass('active-link');
			$('.js-tab-btn-services-block').find('p').slideUp(350);
			$('#' + pathId).addClass('active-link');
			$('#' + pathId).find('p').slideDown(350);

			const textid = $('#' + pathId).data('text');
			$('.js-services-block-map-text').removeClass('active-text');
			$('#' + textid).addClass('active-text');

			if ($(window).width() < 992) {
				$('.js-nav-services-block').slideDown(300, function() {
					if ($(this).is(':visible')) {
						$(this).css('display', 'flex');
					}
				});
				$('.js-tab-btn-services-block').removeClass('active-link-mobile');
				$('#' + pathId).addClass('active-link-mobile');
				const servicesBlockTab = $('#servicesBlockTab');
				if (servicesBlockTab) {
					e.preventDefault();
					$('html, body').animate({
						scrollTop: servicesBlockTab.offset().top - 100
					}, 1000);

					// const targetDiv = $('.js-nav-services-block');
					// targetDiv.scrollTop(0);
				}
			}
		});
	},

	tabsFunction: () => {
		$('.js-tab-btn').on('click', function() {
			$('.triangle-container').remove();
			ShowContent($(this).index());
		});

		ShowContent(0);
		function ShowContent(index) {
			// Make the content visible
			setTimeout(() => {
				$('.tabs .js-tabs-content.visible').removeClass('visible');
				$('.tabs .js-tabs-content:nth-of-type(' + (index + 1) + ')').addClass('visible');
			}, 150);
			setTimeout(() => {
				$('.tabs .js-tabs-content.opacity').removeClass('opacity');
				$('.tabs .js-tabs-content:nth-of-type(' + (index + 1) + ')').addClass('opacity');
			}, 250);

			// Set the tab to selected
			$('.js-tab-btn.selected').removeClass('selected');
			$('.js-tab-btn:nth-of-type(' + (index + 1) + ')').addClass('selected');
		}
	},

	tabFromUrl: () => {
		// Check to see if tab query exists in URL and click on that tab
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});
		const value = params.tab ?? '';
		const cleanedValue = value.replace(/\//g, '');
		const url = window.location.href.split('?')[0];

		if (cleanedValue > 0) {
			$(`.js-tab-btn[data-tab='${cleanedValue}']`).trigger('click');
			window.history.pushState('', '', url);
		}
	},

	tabFromLink: function() {
		$(this).each(function() {
			const linkHref = $(this).attr('href');
			const url = new URL(linkHref, location.origin);
			const tabValue = url.searchParams.get('tab');

			if (tabValue) {
				$(`.js-tab-btn[data-tab='${tabValue}']`).trigger('click');
			}
		});
	},
};

export default Tabs;
